module.exports = __webpack_public_path__ + "img/picalizer.3676f250.png";